{
  "languages": {
    "select": "Selecionar idioma",
    "english": "En",
    "french": "FR",
    "german": "DE",
    "spanish": "ES",
    "portuguese": "PT"
  },
  "nav": {
    "dashboard": "Painel",
    "clients": "Clientes",
    "myBookings": "Minhas Reservas",
    "loginTrainer": "Login do Treinador",
    "login": "Entrar",
    "logout": "Sair",
    "accountSettings": "Configurações da conta",
    "changePassword": "Alterar senha",
    "home": "Início",
    "pricing": "Preços",
    "contact": "Contato",
    "affiliate": "Programa de afiliados",
    "yogaStudioSoftware": "Software para estúdios de yoga",
    "pilatesStudioSoftware": "Software para estúdios de pilates",
    "cantienicaStudioSoftware": "Software para estúdios CANTIENICA",
    "resources": "Recursos",
    "guides": "Guias",
    "blog": "Blog"
  },
  "accountSettings": {
    "title": "Configurações da conta",
    "editTitle": "Editar perfil",
    "firstName": "Nome",
    "lastName": "Sobrenome",
    "email": "Email",
    "phone": "Telefone",
    "updateSuccess": "Perfil atualizado",
    "updateSuccessMessage": "Seu perfil foi atualizado com sucesso",
    "firstNameRequired": "O nome é obrigatório",
    "lastNameRequired": "O sobrenome é obrigatório",
    "dangerZone": "Zona de perigo",
    "deleteAccount": "Excluir minha conta",
    "deleteWarning": "Isso excluirá permanentemente sua conta e todos os dados associados. Esta ação não pode ser desfeita.",
    "confirmDelete": "Tem certeza de que deseja excluir sua conta?",
    "deleteSuccess": "Conta excluída",
    "deleteSuccessMessage": "Sua conta foi excluída com sucesso.",
    "deleteDialog": {
      "title": "Excluir minha conta",
      "description": "Tem certeza de que deseja excluir sua conta e todos os dados associados? Esta ação não pode ser desfeita."
    }
  },
  "password": {
    "changeTitle": "Alterar senha",
    "current": "Senha atual",
    "new": "Nova senha",
    "confirm": "Confirmar nova senha",
    "error": "Erro",
    "mismatch": "As novas senhas não coincidem",
    "updateSuccess": "Senha atualizada",
    "updateSuccessMessage": "Sua senha foi atualizada com sucesso",
    "currentPasswordRequired": "A senha atual é obrigatória",
    "newPasswordRequired": "A nova senha é obrigatória",
    "confirmPasswordRequired": "A confirmação da senha é obrigatória",
    "passwordsDoNotMatch": "As senhas não coincidem"
  },
  "classes": {
    "title": "Aulas disponíveis",
    "bookIntro": "Marque a sua próxima sessão com os nossos formadores especializados",
    "bookNow": "Reservar agora",
    "online": "Online",
    "spots": "Vagas restantes",
    "noClassesAvailableClearFilter": "Nenhuma aula disponível. Tente outra data ou limpe o filtro para ver todas as aulas disponíveis.",
    "noClassesAvailable": "Nenhuma aula disponível.",
    "confirmBookingTitle": "Aula Reservada!",
    "confirmBookingDescription": "Você reservou com sucesso a aula {title} com {trainer} em {date} às {time}."
  },
  "classForm": {
    "title": "Título",
    "datetime": "Data/Hora",
    "duration": "Duração",
    "capacity": "Capacidade",
    "price": "Preço",
    "currency": "Moeda",
    "status": "Status",
    "statusOptions": {
      "available": "Disponível",
      "canceled": "Cancelado",
      "hidden": "Oculto"
    },
    "location": "Localização",
    "locationOptions": {
      "studio": "Estúdio",
      "online": "Online"
    },
    "trainer": "Treinador",
    "isRecurring": "Aula recorrente",
    "submit": "Enviar",
    "repeatEvery": "Repete a cada",
    "repeatPeriod": "Período",
    "repeatPeriodOptions": {
      "week": "Semana",
      "month": "Mês",
      "year": "Ano"
    },
    "maxEvents": "Número máximo de eventos",
    "validation": {
      "titleRequired": "O título deve ter pelo menos 2 caracteres.",
      "minCapacity": "A capacidade deve ser de pelo menos 1.",
      "maxEvents": "O número máximo de eventos deve estar entre 1 e 24."
    },
    "cancelClass": "Cancelar aula",
    "deleteClass": "Excluir aula",
    "cancelDialog": {
      "title": "Cancelar aula",
      "description": "Tem certeza de que deseja cancelar esta aula? Esta ação não pode ser desfeita."
    },
    "deleteDialog": {
      "title": "Excluir aula",
      "description": "Tem certeza de que deseja excluir esta aula? Esta ação não pode ser desfeita."
    },
    "cancelSuccess": {
      "title": "Aula cancelada",
      "description": "A aula foi cancelada com sucesso."
    },
    "deleteSuccess": {
      "title": "Aula excluída",
      "description": "A aula foi excluída com sucesso."
    },
    "createSuccess": {
      "title": "Classe criada",
      "description": "A classe foi criada com sucesso."
    }
  },
  "classCard": {
    "editClass": "Editar aula",
    "enrolled": "inscrito",
    "status": "Status",
    "at": "em",
    "min": "Min.",
    "spots": "vagas",
    "location": "Localização",
    "trainer": "Treinador",
    "enrolledClients": "Clientes inscritos",
    "noEnrolledClients": "Nenhum cliente inscrito.",
    "confirmRemoval": "Confirmar remoção",
    "confirmRemovalDescription": "Tem certeza de que deseja remover {{name}} da aula?",
    "clientHistory": "Histórico de reservas de {{name}}",
    "lastBookings": "Abaixo está o histórico das últimas 10 reservas feitas por este cliente.",
    "bookNow": "Reservar agora",
    "booked": "Reservado",
    "classFullyBooked": "Lotado"
  },
  "bookingSummary": {
    "title": "Resumo da reserva",
    "description": "Por favor, revise os detalhes da sua reserva de aula",
    "min": "Min.",
    "cancellationPolicy": "Você pode cancelar sua reserva até 24 horas antes do início da aula sem custo. Para cancelamentos feitos com menos de 24 horas antes do início, a taxa integral será cobrada.",
    "agreeText": "Ao prosseguir, você concorda com nossos",
    "terms": "Termos",
    "and": "e",
    "privacyPolicy": "Política de privacidade",
    "confirmBooking": "Confirmar reserva",
    "sessions": "Número de sessões",
    "selectSessions": "Selecione o número de sessões",
    "sessionsDescription": "Por favor, selecione quantas sessões deseja reservar.",
    "bookingFailedTitle": "Falha na reserva",
    "bookingFailedDescription": "Não foi possível reservar a aula. Tente novamente mais tarde.",
    "bookingFullDescription": "Esta aula está cheia. Por favor, escolha outra sessão ou data."
  },
  "login": {
    "title": "Entrar",
    "description": "Digite suas credenciais para acessar sua conta",
    "email": "Email",
    "emailPlaceholder": "Digite seu email",
    "password": "Senha",
    "signIn": "Entrar",
    "forgotPassword": "Esqueceu a senha?"
  },
  "terms": {
    "title": "Termos e Condições",
    "scope": {
      "title": "1. Âmbito",
      "description": "Estes Termos e Condições (\"Termos\") aplicam-se ao uso da nossa plataforma de reserva de estúdios de fitness (\"App\"), que permite que estúdios de fitness publiquem suas aulas e os usuários as reservem. Ao se registrar e usar o App, você concorda em estar vinculado a estes Termos."
    },
    "services": {
      "title": "2. Serviços Prestados",
      "description": "Nosso App permite que os usuários:",
      "features": {
        "browse": "Naveguem e reservem aulas de fitness oferecidas por estúdios participantes.",
        "manage": "Gerenciem suas reservas através de sua conta de usuário."
      },
      "disclaimer": "Atuamos apenas como provedores da plataforma e não somos responsáveis pela qualidade, disponibilidade ou execução das aulas de fitness oferecidas por terceiros."
    },
    "registration": {
      "title": "3. Registro e Contas de Usuário",
      "points": {
        "accurateInfo": "Os usuários devem fornecer informações precisas e atualizadas durante o registro.",
        "confidentiality": "Cada usuário é responsável por manter a confidencialidade de suas credenciais de conta.",
        "payment": "Este aplicativo é completamente gratuito para os usuários. Não cobramos nenhuma taxa pelas reservas de aulas, e os usuários nunca serão solicitados a fazer pagamentos através do aplicativo."
      }
    },
    "booking": {
      "title": "4. Reservas e Cancelamentos",
      "points": {
        "binding": "As reservas são vinculativas após confirmação.",
        "cancellationPolicy": "Cada estúdio de fitness define sua própria política de cancelamento, à qual os usuários devem aderir.",
        "refunds": "Não somos responsáveis por reembolsos ou cancelamentos; esses são tratados pelos respectivos estúdios de fitness."
      }
    },
    "responsibilities": {
      "title": "5. Responsabilidades do Usuário",
      "points": {
        "lawfulUse": "Os usuários concordam em usar o App de forma legal e não para atividades fraudulentas.",
        "studioRules": "Os usuários devem seguir as regras e políticas dos estúdios de fitness com os quais reservam."
      }
    },
    "liability": {
      "title": "6. Responsabilidade",
      "points": {
        "injuries": "Não somos responsáveis por lesões, danos ou perdas ocorridos durante ou como resultado da participação nas aulas reservadas.",
        "technicalMalfunctions": "Nossa responsabilidade por danos devido a falhas técnicas do App é limitada a casos de negligência grave ou intenção."
      }
    },
    "dataProtection": {
      "title": "7. Proteção de Dados",
      "points": {
        "gdpr": "Os dados do usuário são processados de acordo com nossa Política de Privacidade e o GDPR."
      }
    },
    "termination": {
      "title": "8. Rescisão e Suspensão de Conta",
      "points": {
        "suspension": "Reservamo-nos o direito de suspender ou encerrar contas que violem estes Termos."
      }
    },
    "governingLaw": {
      "title": "9. Lei Aplicável e Resolução de Conflitos",
      "points": {
        "germanLaw": "Estes Termos são regidos pela lei alemã.",
        "disputeResolution": "Quaisquer disputas serão resolvidas nos tribunais alemães."
      }
    }
  },
  "privacy": {
    "title": "Política de Privacidade",
    "introduction": {
      "title": "1. Introdução",
      "description": "Esta Política de Privacidade explica como coletamos, usamos e protegemos seus dados pessoais ao usar nosso aplicativo, em conformidade com o Regulamento Geral de Proteção de Dados (GDPR) e as leis alemãs de proteção de dados."
    },
    "dataController": {
      "title": "2. Controlador de Dados",
      "description": "PraxiPro é o controlador de dados responsável pelo processamento de seus dados pessoais."
    },
    "dataCollected": {
      "title": "3. Dados Coletados",
      "description": "Coletamos os seguintes dados:",
      "points": {
        "account": "Apenas o nome e o e-mail são necessários para a criação da conta.",
        "booking": "Histórico de reservas e preferências."
      }
    },
    "purpose": {
      "title": "4. Finalidade do Processamento de Dados",
      "description": "Seus dados são processados para as seguintes finalidades:",
      "points": {
        "account": "Fornecer e gerenciar sua conta.",
        "booking": "Facilitar reservas de aulas.",
        "compliance": "Garantir conformidade com nossos Termos e melhorar nossos serviços."
      }
    },
    "dataSharing": {
      "title": "5. Compartilhamento de Dados",
      "points": {
        "fitnessStudios": "Seus dados são compartilhados apenas com os estúdios de fitness para facilitar sua reserva."
      }
    },
    "dataSecurity": {
      "title": "6. Segurança de Dados",
      "description": "Implementamos medidas técnicas e organizacionais para proteger seus dados contra acesso não autorizado e uso indevido."
    },
    "dataRetention": {
      "title": "7. Retenção de Dados",
      "points": {
        "retention": "Retemos seus dados enquanto forem necessários para a prestação de nossos serviços ou conforme exigido por lei.",
        "deletion": "Se você optar por excluir sua conta, o aplicativo removerá permanentemente todos os dados associados à sua conta. Nenhuma informação pessoal ou dados relacionados serão retidos, e suas informações serão completamente apagadas do nosso sistema."
      }
    },
    "userRights": {
      "title": "8. Seus Direitos",
      "description": "Como usuário, você tem os seguintes direitos sob o GDPR:",
      "points": {
        "access": "Direito de acessar, corrigir ou excluir seus dados pessoais.",
        "object": "Direito de se opor ao processamento de dados.",
        "portability": "Direito à portabilidade de dados."
      }
    },
    "contact": {
      "title": "9. Informações de Contato",
      "description": "Para quaisquer dúvidas relacionadas à privacidade, entre em contato conosco em [hello@praxipro.de]."
    },
    "changes": {
      "title": "10. Alterações nesta Política",
      "description": "Podemos atualizar esta Política de Privacidade periodicamente. Os usuários serão informados sobre alterações significativas."
    },
    "consent": {
      "description": "Ao usar nosso aplicativo, você concorda com os termos descritos nesta Política de Privacidade."
    }
  },
  "clientDashboard": {
    "title": "Minhas Reservas",
    "bookedClasses": "Minhas aulas reservadas",
    "cancelSuccess": {
      "title": "Reserva cancelada",
      "description": "Sua reserva de aula foi cancelada com sucesso"
    },
    "cancelDialog": {
      "title": "Cancelar reserva",
      "description": "Tem certeza que deseja cancelar esta reserva? Esta ação não pode ser desfeita."
    },
    "cannotCancel": "Não é possível cancelar dentro de 24h"
  },
  "dashboard": {
    "createNewClass": "Criar nova aula",
    "upcomingClasses": "Aulas futuras",
    "historicalClasses": "Aulas históricas",
    "createClass": {
      "title": "Criar nova aula",
      "description": "Preencha os detalhes para sua nova aula.",
      "create": "Criar aula"
    },
    "editClass": {
      "title": "Editar aula",
      "description": "Atualize os detalhes da sua aula.",
      "update": "Atualizar aula"
    },
    "stats": {
      "totalClasses": "Total de aulas",
      "totalStudents": "Total de alunos"
    }
  },
  "forgotPassword": {
    "title": "Redefinir senha",
    "description": "Digite seu endereço de e-mail e enviaremos um link para redefinir sua senha.",
    "emailLabel": "E-mail",
    "emailPlaceholder": "Digite seu e-mail",
    "sendResetLinkButton": "Enviar link de redefinição",
    "sendingButton": "Enviando...",
    "backToLoginButton": "Voltar para o login",
    "rememberPassword": "Lembra sua senha?",
    "toastSuccessTitle": "Link de redefinição enviado",
    "toastSuccessDescription": "Se existir uma conta com este e-mail, você receberá um link para redefinir sua senha.",
    "toastErrorTitle": "Erro ao redefinir senha",
    "toastErrorDescription": "Houve um problema ao redefinir sua senha. Por favor, tente novamente mais tarde."
  },
  "resetPassword": {
    "title": "Redefinir senha",
    "description": "Insira sua nova senha para concluir a redefinição.",
    "confirmRegistrationTitle": "Escolha uma senha",
    "confirmRegistrationDescription": "Digite sua nova senha para concluir o processo de registro.",
    "newPasswordLabel": "Nova senha",
    "confirmPasswordLabel": "Confirmar senha",
    "sendResetLinkButton": "Enviar redefinição",
    "sendingButton": "Enviando...",
    "toastPasswordMismatchTitle": "As senhas não coincidem",
    "toastPasswordMismatchDescription": "Certifique-se de que ambas as senhas são iguais.",
    "toastSuccessTitle": "Redefinição de senha bem-sucedida",
    "toastSuccessDescription": "Sua senha foi redefinida com sucesso.",
    "toastErrorTitle": "Erro ao redefinir a senha",
    "toastErrorDescription": "Houve um problema ao redefinir sua senha. Por favor, tente novamente mais tarde."
  },
  "authDialog": {
    "loginTitle": "Faça login para reservar a aula",
    "signUpTitle": "Cadastre-se para reservar a aula",
    "loginDescription": "Faça login para confirmar sua reserva",
    "signUpDescription": "Crie uma conta para reservar aulas",
    "firstName": "Nome",
    "firstNamePlaceholder": "John",
    "lastName": "Sobrenome",
    "lastNamePlaceholder": "Doe",
    "email": "Email",
    "emailPlaceholder": "john@example.com",
    "password": "Senha",
    "forgotPassword": "Esqueceu a senha?",
    "loginButton": "Entrar & Reservar",
    "signUpButton": "Cadastrar & Reservar",
    "switchToSignUp": "Não tem uma conta? Cadastre-se",
    "switchToLogin": "Já tem uma conta? Entre",
    "loginFailed": "Falha no login. Por favor, tente novamente.",
    "emailAlreadyExists": "Este e-mail já está registado. Por favor, inicie sessão em vez disso. Se se esqueceu da sua palavra-passe, utilize a opção « Esqueci-me da palavra-passe ».",
    "registrationFailed": "Falha no registro. Por favor, tente novamente.",
    "registrationSuccessful": "Registro bem-sucedido! Por favor, verifique seu e-mail para confirmar seu endereço de e-mail."
  },
  "common": {
    "class": "Aula",
    "date": "Data",
    "time": "Hora",
    "duration": "Duração",
    "trainer": "Instrutor",
    "price": "Preço",
    "location": "Local",
    "status": "Status",
    "actions": "Ações",
    "minutes": "minutos",
    "completed": "Concluído",
    "cancel": "Cancelar",
    "delete": "Excluir",
    "close": "Fechar",
    "booked": "Reservado",
    "canceled": "Cancelado",
    "keepBooking": "Manter reserva",
    "confirmCancel": "Sim, cancelar",
    "backToClasses": "Voltar para as aulas",
    "logout": "Sair",
    "pickMonth": "Escolha um mês",
    "pickDate": "Escolha uma data",
    "clear": "Limpar",
    "remove": "Remover",
    "submit": "Enviar",
    "pleaseWait": "Por favor, aguarde..."
  },
  "contactUs": {
    "title": "Precisa de ajuda? Fale com nossos especialistas em software de agendamento",
    "getInTouch": "Entre em contato para registrar seu estúdio e iniciar seu teste gratuito",
    "subHeading": "Adoraríamos ouvir você! Seja uma dúvida sobre funcionalidades, preços ou qualquer outra coisa — nossa equipe está pronta para ajudar.",
    "fillOutContactForm": "Preencha o formulário e entraremos em contato o mais breve possível.",
    "name": "Nome",
    "enterName": "Digite seu nome",
    "email": "Email",
    "enterEmail": "Digite seu email",
    "studioName": "Nome do estúdio",
    "enterStudioName": "Digite o nome do estúdio",
    "message": "Mensagem",
    "enterMessage": "Digite sua mensagem",
    "sendMessage": "Enviar mensagem",
    "sendingMessage": "Enviando mensagem",
    "submit": "Enviar",
    "nameMin": "O nome deve ter no mínimo 2 caracteres.",
    "emailInvalid": "Por favor, insira um endereço de email válido.",
    "messageMin": "A mensagem deve ter no mínimo 10 caracteres.",
    "requestSent": "Solicitação enviada",
    "weWillGetBack": "Entraremos em contato em breve!",
    "toastErrorTitle": "Ocorreu um erro",
    "toastErrorDescription": "Ocorreu um erro ao processar sua solicitação. Tente novamente mais tarde.",
    "alertStudioProfessional": "Este formulário é destinado a profissionais que desejam registrar seu estúdio.",
    "needSupport": {
      "title": "Precisa de suporte?",
      "description": "Obtenha respostas imediatas."
    },
    "feedback": {
      "title": "Feedback?",
      "description": "Conte para nós aqui."
    },
    "reportIssue": {
      "title": "Relatar problema",
      "description": "Receba suporte prioritário."
    },
    "community": {
      "title": "Comunidade",
      "description": "Conecte-se com outros usuários."
    }
  },
  "landing": {
    "title": "Software de gestão de estúdios para academias",
    "heroTitle": "Aplicativo moderno para estúdios de Yoga, Pilates, Fisioterapia e CANTIENICA",
    "heroDescription": "A plataforma tudo-em-um para proprietários de estúdios de fitness para gerenciar aulas, clientes e expandir seus negócios de forma eficiente.",
    "ctaText": "Comece o Teste Gratuito",
    "featuresSectionTitle": "Tudo o que Você Precisa para Gerenciar Seu Estúdio",
    "featuresSectionDescription": "Ferramentas poderosas projetadas especificamente para proprietários de estúdios de fitness",
    "classManagementTitle": "Gestão de Aulas",
    "classManagementDescription": "Gerencie facilmente seu horário de aulas, faça reservas e acompanhe a presença em tempo real",
    "clientManagementTitle": "Gestão de Clientes",
    "clientManagementDescription": "Acompanhe seus clientes, seu histórico de reservas e gerencie as adesões em um só lugar",
    "businessAnalyticsTitle": "Análise de Negócios",
    "businessAnalyticsDescription": "Obtenha informações sobre o desempenho do seu estúdio com relatórios e análises detalhadas",
    "benefitsSectionTitle": "Faça Seu Negócio Crescer com Ferramentas Inteligentes",
    "benefitsSectionDescription": "Ferramentas inteligentes para ajudar a crescer seu negócio.",
    "benefit1": "Reduza faltas com lembretes automáticos",
    "benefit2": "Aumente a receita com opções de preços flexíveis",
    "benefit3": "Ganhe tempo com agendamento automatizado",
    "benefit4": "Melhore a retenção de clientes com ferramentas de engajamento",
    "benefit5": "Tome decisões baseadas em dados com análises detalhadas",
    "benefit6": "Otimize as operações com ferramentas integradas",
    "ctaSectionTitle": "Pronto para Transformar a Gestão do Seu Estúdio?",
    "ctaSectionDescription": "Junte-se aos proprietários de estúdios bem-sucedidos que otimizaram suas operações com nossa plataforma.",
    "featuredStudiosTitle": "Estúdios em destaque usando o FitCalendar",
    "featuredStudiosIntro": "Junte-se a esses negócios de fitness de sucesso que transformaram suas operações com nossa plataforma",
    "physiotherapyPractice": "Clínica de fisioterapia",
    "onlineBooking": "Agendamento online",
    "howFitCalendarWorksTitle": "Como o FitCalendar funciona",
    "howFitCalendarWorksIntro": "Comece em quatro passos simples",
    "howFitCalendarWorksStep1Title": "Cadastre-se",
    "howFitCalendarWorksStep1Intro": "Crie sua conta e configure seu perfil em minutos",
    "howFitCalendarWorksStep2Title": "Crie",
    "howFitCalendarWorksStep2Intro": "Adicione suas aulas e prepare seu estúdio para agendamentos",
    "howFitCalendarWorksStep3Title": "Integre",
    "howFitCalendarWorksStep3Intro": "Conecte suas ferramentas existentes e adicione o link de agendamento ao seu site",
    "howFitCalendarWorksStep4Title": "Cresça",
    "howFitCalendarWorksStep4Intro": "Concentre-se nos seus clientes enquanto cuidamos da parte administrativa",
    "viewPricing": "Ver preços",
    "rating": "Avaliação",
    "happyUsers": "Usuários satisfeitos",
    "freeTrial": "Teste gratuito",
    "realTimeDashboard": "Painel do estúdio em tempo real",
    "trackYourStudioPerformance": "Acompanhe o desempenho do seu estúdio"
  },
  "pricing": {
    "title": "Preços",
    "header": "Planos acessíveis de software de agendamento fitness",
    "subHeader": "Uma assinatura acessível para tudo o que sua clínica precisa — agendamento de aulas, reservas de clientes e gestão de estúdio facilitada.",
    "freeTrial": "Teste gratuito",
    "freeTrialDesc": "Para estúdios que estão testando a plataforma",
    "freeTrialFeatures": [
      "Acesso completo por 14 dias",
      "Gestão básica de calendário",
      "Até 5 aulas por semana",
      "Perfis básicos de clientes"
    ],
    "startFreeTrial": "Iniciar teste gratuito",
    "standard": "Padrão",
    "standardDesc": "Por estúdio, cobrado mensalmente",
    "standardFeatures": [
      "Aulas e agendamentos ilimitados",
      "Gestão avançada de calendário",
      "Reservas online para clientes",
      "Sistema completo de gestão de clientes",
      "Integração com pagamentos",
      "Relatórios e análises básicas",
      "Suporte por e-mail"
    ],
    "subscribeNow": "Assinar agora",
    "annual": "Anual",
    "annualDesc": "Economize 20% com cobrança anual",
    "annualFeatures": [
      "Todos os recursos do plano Padrão",
      "2 meses grátis (equivalente a 16€/mês)",
      "Suporte prioritário ao cliente",
      "Relatórios e análises avançadas"
    ],
    "subscribeAnnually": "Assinar anualmente",
    "popularPlan": "Mais popular",
    "perMonth": "/mês",
    "perYear": "/ano",
    "faqsTitle": "Perguntas Frequentes",
    "faqsQ1": "Posso alterar meu plano?",
    "faqsA1": "Sim, você pode fazer upgrade para o plano anual a qualquer momento. O downgrade estará disponível ao final da assinatura anual.",
    "faqsQ2": "Vocês oferecem descontos para múltiplos estúdios?",
    "faqsA2": "Sim! Para estúdios com várias unidades, oferecemos descontos por volume. Entre em contato com nosso time de vendas.",
    "faqsQ3": "Quais formas de pagamento vocês aceitam?",
    "faqsA3": "Aceitamos todos os principais cartões de crédito e PayPal. Para planos anuais, também aceitamos transferências bancárias.",
    "faqsQ4": "Existe uma taxa de configuração?",
    "faqsA4": "Não, não há taxas ocultas. Sua assinatura cobre tudo: configuração, hospedagem e atualizações regulares."
  },
  "affiliate": {
    "title": "Programa de Afiliados",
    "heading": "💼 Junte-se ao nosso Programa de Afiliados",
    "description": "Ganhe dinheiro indicando instrutores de Yoga, Pilates, Fitness, fisioterapeutas, profissionais de CANTIENICA e treinadores de movimento para o FitCalendar. É fácil, recompensador e cresce com você.",
    "rewardOne": {
      "amount": "💶 96 €",
      "text": "por cada novo usuário que assinar por um ano completo."
    },
    "rewardTwo": {
      "amount": "📅 8 €/mês",
      "text": "por usuário durante um ano se optar pelo pagamento mensal."
    },
    "rewardThree": {
      "title": "🏆 Bônus Vitalício:",
      "description": "Indique mais de 50 usuários pagantes e receba",
      "amount": "3 €/mês",
      "forever": "para sempre"
    },
    "ctaHeading": "🎉 Comece hoje mesmo",
    "ctaDescription": "Preencha o formulário abaixo e receba seu código de referência por e-mail. Compartilhe e comece a ganhar!",
    "form": {
      "firstName": "Nome",
      "lastName": "Sobrenome",
      "email": "Endereço de e-mail",
      "submit": "Obter meu código de referência",
      "loading": "Registrando..."
    },
    "firstNameMin": "O nome é obrigatório",
    "lastNameMin": "O sobrenome é obrigatório",
    "emailInvalid": "Endereço de e-mail inválido"
  },
  "register": {
    "title": "Registro do Estúdio",
    "description": "Registre seu estúdio e comece seu teste gratuito",
    "name": "Nome",
    "enterName": "Digite seu nome",
    "email": "Email",
    "enterEmail": "Digite seu email",
    "studioName": "Nome do Estúdio",
    "enterStudioName": "Digite o nome do estúdio",
    "message": "Mensagem",
    "enterMessage": "Digite sua mensagem",
    "sendMessage": "Enviar mensagem",
    "sendingMessage": "Enviando mensagem",
    "submit": "Enviar",
    "submitting": "Enviando...",
    "nameMin": "O nome deve ter pelo menos 2 caracteres.",
    "emailInvalid": "Por favor, insira um email válido.",
    "messageMin": "A mensagem deve ter pelo menos 10 caracteres.",
    "requestSent": "Solicitação enviada",
    "weWillGetBack": "Entraremos em contato em breve!",
    "toastErrorTitle": "Erro ocorrido",
    "toastErrorDescription": "Ocorreu um erro ao processar sua solicitação. Por favor, tente novamente mais tarde.",
    "alertStudioProfessional": "Este formulário é destinado a profissionais de estúdios que desejam registrar seu estúdio."
  },
  "guides": {
    "title": "Biblioteca de recursos"
  },
  "blog": {
    "title": "Dicas de Yoga, Pilates, CANTIENICA e Fitness"
  },
  "clients": {
    "title": "Lista de clientes",
    "description": "Gerencie seus clientes de fitness e veja seu histórico de reservas.",
    "listTitle": "Banco de dados de clientes",
    "searchPlaceholder": "Pesquisar por nome ou email...",
    "searchButton": "Pesquisar",
    "searching": "Pesquisando...",
    "table.name": "Nome",
    "table.email": "Email",
    "table.totalBookings": "Total de reservas",
    "table.actions": "Ações",
    "table.class": "Aula",
    "table.date": "Data",
    "table.time": "Hora",
    "table.duration": "Duração",
    "table.price": "Preço",
    "table.status": "Status",
    "viewClasses": "Ver reservas",
    "loading": "Carregando...",
    "noClientsFound": "Nenhum cliente encontrado.",
    "searchError.apiTitle": "Erro de API",
    "searchError.apiDescription": "Falha ao carregar dados do servidor.",
    "searchError.title": "Aviso de pesquisa",
    "minLengthWarning": "Por favor, insira pelo menos 3 caracteres para pesquisar.",
    "bookingsTitle": "Reservas de {{name}}",
    "noBookings": "Nenhum dado de reserva disponível.",
    "bookingsDescription": "Abaixo está o histórico de todas as reservas feitas por este cliente.",
    "status.booked": "Reservado",
    "status.canceled": "Cancelado"
  }
}